/**
 * Generates 2-letter initials from an organization name
 * - If name has 2+ words: first letter of first two words
 * - If name has 1 word: first 2 letters
 * - Always uppercase
 *
 * Examples:
 * - "JetBrains" → "JE"
 * - "Grid Dynamics" → "GD"
 * - "Personal Space" → "PS"
 */
export function getOrganizationInitials(name: string): string {
  if (!name || name.trim().length === 0) {
    return 'OR' // Default fallback
  }

  const trimmed = name.trim()
  const words = trimmed.split(/\s+/).filter(word => word.length > 0)

  if (words.length >= 2) {
    // Take first letter of first two words
    return (words[0]![0]! + words[1]![0]!).toUpperCase()
  } else {
    // Take first two characters of single word
    return trimmed.substring(0, 2).toUpperCase()
  }
}
